import CragModel from '../../core/crag_model';

export function toCragViewModel(crag: CragModel | null) {
    if (!crag) {
        return {
            name: '',
            lines: [],
            boulders: []
        };
    }
    let lines = [];
    lines = crag.boulders?.flatMap(boulder => boulder.lines?.flatMap(line => line) || []) || [];
    return {
        name: crag.feature.get('name'),
        lines: lines,
        boulders: crag.boulders
    };
}
